export enum ResourceType {
  Topic = 'topic',
  Video = 'video',
}

export type Resource = {
  label: string,
  href: string,
}

export type Video = {
  subject: string,
  videoId: string,
  title: string,
}

export interface VideoPlayerProps {
  videoId: string,
  youtubeId: string,
  title: string,
  description?: string,
  host: string,
  uploadDatetime: number,
  resources?: Resource[],
  topicResources?: Resource[],
  topicVideos?: Video[],
  relatedVideos?: Video[],
  onVideoEnd?: (nextVideoSubject: string, nextVideoId: string) => void,
  getVideoHref: (subject: string, videoId: string) => string,
  onResourceClick?: (href: string) => void,
  autoplay?: boolean,
}
